export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'learn more',
    },
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;

      if (widgetCount == 0) {
        $('.tier-4-container .inner-container').addClass('seo-no-data');
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName} .card-widget-item`).each(function () {
          const newTitle = data.items[0].Title;

          $(this)
            .find('.card-widget-title')
            .replaceWith(`<h1 class="main-title"">${newTitle}</h1>`);

          $(this).find('.moreButton').removeAttr('target');
          $(this).find('.moreButton').addClass('button');
          $(this).find('.button').removeClass('moreButton');
          $(`#${widgetName} .card-widget-description, .main-title`).wrapAll(
            '<div class="main-content-seo"></div>',
          );
        });
      }
    },
  });
}
